import { useState, useEffect, useContext } from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { MessengerContext } from "../../../contexts/MessengerContext";

const TemplateSelect = ({ showCustom }) => {
  const { templates, templateId, setTemplateId } = useContext(MessengerContext);
  const [selectedTemplate, setSelectedTemplate] = useState(null);



  useEffect(() => {
    if (selectedTemplate !== templateId) {
      setSelectedTemplate(templateId);
    }
  }, [templateId]);

  const handleChange = (e) => {
    setSelectedTemplate(e.target.value);
    setTemplateId(e.target.value);
  };

  return (
    <FormControl style={{ width: 300 }} size="small">
      <InputLabel id="label">Template</InputLabel>
      <Select
        labelId="label"
        value={selectedTemplate || ""}
        label="template"
        onChange={handleChange}
      >
        {showCustom ? <MenuItem value={"custom"}>Custom</MenuItem> : null}
        {templates.map((item) => {
          return (
            <MenuItem key={item._id} value={item._id}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default TemplateSelect;
